import React from 'react';
import Sortable from 'react-sortablejs';
import _get from 'lodash/get';
import CategorySubItem from './CategorySubItem';
import {itemStyle, disableItemStyle} from './styles';

export default function CategoryItem({
  item,
  isDisabled,
  toggleItemStatus,
  preview,
  isSupportSubOptions = false,
  type = 'enable',
  sortable = false,
  onDragSubItem,
}) {
  const showSubOptions = isSupportSubOptions
    ? _get(item, 'options', []).length > 0
    : false;

  const isTypeisEnable = type === 'enable';

  return (
    <div
      data-id={item.value}
      style={isDisabled ? disableItemStyle : itemStyle}
      key={item.value}
    >
      <div className="d-flex align-items-center justify-content-center">
        {!preview && (
          <i
            className={`fa ${
              isTypeisEnable ? 'fa-bars' : 'fa-plus'
            } draggable cursor-pointer kt-margin-r-10`}
            onClick={() =>
              isTypeisEnable
                ? {}
                : toggleItemStatus(item.value, 'enable', false, true)
            }
          />
        )}
        <div className="text-center w-100">{item.label}</div>
        {!preview && (
          <i
            className={`fa ${isTypeisEnable ? 'fa-times' : ''} cursor-pointer`}
            onClick={() => toggleItemStatus(item.value, 'disable', false, true)}
          />
        )}
      </div>
      {showSubOptions && sortable && (
        <>
          {item.options
            .filter(subItem => subItem.isRequired)
            .map(subItem => (
              <CategorySubItem
                key={subItem.value}
                item={subItem}
                isDisabled={isDisabled}
                toggleItemStatus={toggleItemStatus}
                preview={preview}
              />
            ))}
          <Sortable
            options={{handle: '.draggable', filter: '.fixed'}}
            tag="div"
            onChange={order => onDragSubItem(order, item.value)}
          >
            {item.options
              .filter(subItem => !subItem.isRequired)
              .map(subItem => (
                <CategorySubItem
                  key={subItem.value}
                  item={subItem}
                  isDisabled={isDisabled}
                  toggleItemStatus={toggleItemStatus}
                  preview={preview}
                />
              ))}
          </Sortable>
        </>
      )}
      {showSubOptions && !sortable && (
        <>
          {item.options.map(subItem => (
            <CategorySubItem
              key={subItem.value}
              item={subItem}
              isDisabled={isDisabled}
              toggleItemStatus={toggleItemStatus}
              preview={preview}
            />
          ))}
        </>
      )}
    </div>
  );
}
